import gql from 'graphql-tag'

export const DOWNLOAD_SERVICE_WORK_ORDER = gql`
  query ServiceWorkOrder($filter: GetServiceOrderFilter!) {
    serviceWorkOrder(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceWorkOrder {
        base64
      }
    }
  }
`
